import $ from "jquery";
import GPPYPurchase from './gppy-purchase.svelte';
import GPPYSubscriberPurchase from './gppy-subscriber-purchase.svelte';
import './gppy-misc.js';
import {getParameterByName} from "./gppy-misc";

function init() {
    $.get('/api/productList').then((productTable) => {
        $('.dropdownUsersNum a').click(function (e) {
            var prod = $(e.target).attr('product');
            var priceLabel = productTable[prod].currencyPrefix + productTable[prod].price + productTable[prod].currencyPostfix;
            $(e.target).parents('.pricingoption').find('.price').text(priceLabel);
            $('#dropdownUsersNum .users').text($(e.target).text());
            $(e.target).parents('.pricingoption').find('.buyButton').attr('product', prod);
            $(e.target).parents('.dropdown').find('button.dropdown-toggle').dropdown('toggle');
            return false;
        })

        $('.dropdownPeriodNum a').click(function (e) {
            var prod = $(e.target).attr('product');
            var priceLabel = productTable[prod].currencyPrefix + productTable[prod].price + productTable[prod].currencyPostfix;
            $(e.target).parents('.extraoption').find('.price').text(priceLabel);
            $('#dropdownPeriodNum .period').text($(e.target).text());
            $(e.target).parents('.extraoption').find('.buySubscriberButton').attr('product', prod);
            $(e.target).parents('.dropdown').find('button.dropdown-toggle').dropdown('toggle');
            return false;
        })

        $('.buyButton').click((ev) => {
            let email = $(ev.target).attr('customeremail');
            let product = $(ev.target).attr('product');
            let country = $(ev.target).attr('country');
            let props = {
                    email: email,
                    product: product,
                    productTable: productTable
                };
            if (country) props['prevCountryCode'] = country;
            let component = new GPPYPurchase({
                target: document.body,
                props: props
            });
            component.showPurchaseForm();
        });

        $('.buySubscriberButton').click((ev) => {
            let email = $(ev.target).attr('customeremail');
            let product = $(ev.target).attr('product');
            let component = new GPPYSubscriberPurchase({
                target: document.body,
                props: {
                    product: product,
                    productTable: productTable
                }
            });
            component.showPurchaseForm();
        });
    })


    var offer = getParameterByName("offer");
    if (offer === "PAO_VD" || offer === "PS6" || offer === "PS12") {
        $('html, body').animate({
            scrollTop: $(".extrasection").offset().top
        }, 2000);
    }
}

$('document').ready(() => {
    if ($('.pricingpage').length) {
        init();
    }
})

